import $ from "jquery";
import { EVENT_GLOBAL_ATTACH } from "base/FormValidator";
import GlobalEvents from "base/GlobalEvents";
import AjaxLoadedWebsiteModal, { EVENT_MODAL_CONTENT_LOADING_FAILED } from "modal/AjaxLoadedWebsiteModal";
import WebsiteModal, { GLOBAL_EVENT_MODAL_CREATED, EVENT_MODAL_BUILT } from "modal/WebsiteModal";

GlobalEvents.on(EVENT_GLOBAL_ATTACH, (validator) => {

    validator.on('input:showMessage', (data) => {
        data.input.$input.closest('.form__row').addClass('form__row--error');
    }).on('input:hideMessage', (data) => {
        data.input.$input.closest('.form__row').removeClass('form__row--error');
    });

});

$.extend(true, AjaxLoadedWebsiteModal.global_settings, {
    buildLoadingModal: () => (
        eotwJSXFactory('div', {className: "modal modal--loading"}, [
            eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
            eotwJSXFactory('div', {className: "modal__container"}, [
                eotwJSXFactory('button', {type: "button", className: "modal__close-btn js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__content"}, [
                    eotwJSXFactory('div', {className: "modal__loading"})
                ])
            ])
        ])
    ),
});

WebsiteModal.global_settings.selectors.contentContainer = '.modal__content';

GlobalEvents.on(GLOBAL_EVENT_MODAL_CREATED, (modal) => {

    //Do additional stuff is showing an error
    modal.on(EVENT_MODAL_CONTENT_LOADING_FAILED, (error) => {
        //Add error class to the modal
        modal.$modal.addClass('modal--error');

    }).on(EVENT_MODAL_BUILT, () => {

        //Bind an event to the js-retry link
        modal.$modal.on('click', '.js-reload-modal', () => {

            //remove error class from modal and add loading class
            modal.$modal.removeClass('modal--error').addClass('modal--loading');

            //disable cache so it reloads from the request rather than the cache
            modal.allowCache = false;

            //clear error message content and add loading modal
            modal.$modal.find(".modal__content").html(
                eotwJSXFactory('div', {className: "modal__loading"}),
            );

            //reload content
            modal.loadPageContent();

            //renable the cache
            modal.allowCache = true;

            return false;
        }).on('click', '.js-modal-close', () => {
            modal.close();

            return false;
        });

    });
});
